// Bookings table export — pure so it is testable under the admin vitest
// setup, same shape as giftpass.csv.ts.

export interface BookingCsvRow {
  ref: string;
  hub: string;
  service: string;
  scheduledAt: string;
  paymentMethod: string;
  /** `null` when the viewer may not see money (0285) — exported as blank. */
  amountDue: number | null;
  status: string;
}

/** A field that might contain a comma or quote is wrapped, RFC 4180 style. */
function csvField(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replaceAll('"', '""')}"` : value;
}

export function bookingsCsv(rows: readonly BookingCsvRow[]): string {
  const body = rows.map((r) =>
    [
      r.ref,
      r.hub,
      r.service,
      new Date(r.scheduledAt).toLocaleString("en-PH", { dateStyle: "medium", timeStyle: "short" }),
      r.paymentMethod,
      r.amountDue === null ? "" : r.amountDue.toFixed(2),
      r.status,
    ]
      .map(csvField)
      .join(","),
  );
  return ["ref,hub,service,scheduled,payment,amount_due,status", ...body].join("\r\n") + "\r\n";
}

/** A filename that sorts by export date, matching giftpassCsvName's shape. */
export function bookingsCsvName(now: Date = new Date()): string {
  const day = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila" }).format(now);
  return `bookings-${day}.csv`;
}
